// src/lib/account/learnerSupport.js

import { supabase } from "../../supabaseClient";



export async function fetchMyLearnerSupportContacts() {
  const {
    data,
    error,
  } = await supabase.rpc(
    "get_my_learner_support_contacts"
  );

  if (error) {
    throw error;
  }

  return Array.isArray(data)
    ? data
    : [];
}


export async function sendLearnerSupportRequest({
  cohortLearnerId,
  partnerMemberId,
  subject,
  message,
}) {
  const {
    data: sessionData,
    error: sessionError,
  } =
    await supabase.auth.getSession();

  if (sessionError) {
    throw sessionError;
  }

  const accessToken =
    sessionData
      ?.session
      ?.access_token;

  if (!accessToken) {
    throw new Error(
      "Please sign in again before sending a support request."
    );
  }

  const response =
    await fetch(
      "/.netlify/functions/learner-support-request",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json",

          Authorization:
            `Bearer ${accessToken}`,
        },

        body:
          JSON.stringify({
            cohortLearnerId,
            partnerMemberId,
            subject,
            message,
          }),
      }
    );

  const payload =
    await response
      .json()
      .catch(
        () => ({})
      );

  if (
    !response.ok ||
    !payload?.ok
  ) {
    throw new Error(
      payload?.error ||
        "Your support request could not be sent."
    );
  }

  return payload;
}